import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';

import {
  faDeleteLeft,
  faTrashAlt,
  faArrowAltToLeft,
  faArrowAltToRight,
  faSliders,
} from '@fortawesome/pro-regular-svg-icons';
import {faRectangle, faRotateRight} from '@fortawesome/pro-solid-svg-icons';

import styles from '../css/SecondaryAppBar.module.css';
import baseStyles from '../css/Base.module.css';

export default function SecondaryAppBar({
  onClickUndo,
  onClickClear,
  onClickReset,
  onClickNext,
  onClickPrevious,
  onClickFAB,
  onClickCard,
  iconFABType = 'ADD', // ADD, EDIT
}) {
  const isUndoVisible = !!onClickUndo;
  const isClearVisible = !!onClickClear;
  const isResetVisible = !!onClickReset;
  const isCardVisible = !!onClickCard;
  const isPreviousVisible = !!onClickPrevious;
  const isNextVisible = !!onClickNext;
  const isFABVisible = !!onClickFAB;

  return (
    <div className={baseStyles['f-g-1']}>
      <AppBar position="sticky" className="bg-dark-blue">
        <Toolbar variant="dense">
          {isUndoVisible && (
            <IconButton onClick={onClickUndo} edge="start" color="inherit" size="large">
              <FontAwesomeIcon icon={faDeleteLeft} size="xs" />
            </IconButton>
          )}
          {isClearVisible && (
            <IconButton onClick={onClickClear} edge="start" color="inherit" size="large">
              <FontAwesomeIcon icon={faTrashAlt} size="xs" />
            </IconButton>
          )}
          {isResetVisible && (
            <IconButton onClick={onClickReset} edge="start" color="inherit" size="large">
              <FontAwesomeIcon icon={faRotateRight} size="xs" />
            </IconButton>
          )}
          {isCardVisible && (
            <IconButton onClick={onClickCard} edge="start" color="inherit" size="large">
              <FontAwesomeIcon icon={faRectangle} size="xs" />
            </IconButton>
          )}
          <div className={styles.fabContainer}>
            {isPreviousVisible && (
              <Fab onClick={onClickPrevious} className={styles.fabRoot}>
                <FontAwesomeIcon icon={faArrowAltToLeft} className="clr-white" size="2xl" />
              </Fab>
            )}
            {isNextVisible && (
              <Fab onClick={onClickNext} className={styles.fabRoot}>
                <FontAwesomeIcon icon={faArrowAltToRight} className="clr-white" size="2xl" />
              </Fab>
            )}
            {isFABVisible && (
              <Fab className={styles.fabRoot} onClick={onClickFAB}>
                {iconFABType === 'EDIT' ? (
                  <FontAwesomeIcon icon={faSliders} className="clr-white" size="2xl" />
                ) : (
                  <AddIcon style={{color: '#FFF'}} />
                )}
              </Fab>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
